/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGroupCookingNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGroupCookingNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Cook Together!",
    "Group Cooking Night Awaits!",
    "Delicious Fun for Everyone!",
  ],
  title: "Group Cooking Night",
  description: "Organize a fun group cooking night.",
  longDescription:
    "Gather your friends for an exciting group cooking night! Choose a date, decide on dishes to prepare, and plan activities!",
  emoji: "🍽",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Group Cooking Night",
          emoji: "🍽",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the group cooking night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on dishes to prepare?",
            description: "What dishes should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What dishes should we consider?",
                emoji: "🥘",
                completeAction: {
                  question: "Decide on ingredients needed?",
                  description: "What ingredients should we gather for cooking?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🥕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Cook Together!",
    outroDescription:
      "Your group cooking night plans are set! Enjoy the culinary adventure!",
  },
};
